import * as React from 'react'

const SvgLinkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.281 4.225a3.75 3.75 0 00-5.312 0l.887.888A2.506 2.506 0 0117.4 8.656l-5 5a2.504 2.504 0 01-3.544-3.537l.882-.888-.882-.887-.887.887a3.75 3.75 0 000 5.313 3.75 3.75 0 002.656 1.081 3.75 3.75 0 002.669-1.1l5-5a3.75 3.75 0 00-.013-5.3zM2.62 15.512a2.5 2.5 0 010-3.543l5-5a2.5 2.5 0 013.543 0c.469.473.726 1.115.713 1.781a2.5 2.5 0 01-.731 1.781l-1.325 1.344.887.887 1.325-1.325A3.76 3.76 0 106.712 6.12l-5 5a3.75 3.75 0 000 5.319A3.75 3.75 0 004.375 17.5a3.794 3.794 0 002.675-1.1l-.888-.887a2.5 2.5 0 01-3.543 0z"
      fill="#163250"
    />
  </svg>
)

export default SvgLinkIcon
